var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/card-batch-msg-item.html');
/*require('./../../style/msg/text-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var paragraph = '<p class="im-msg-forward-p">${name}: ${message}</p>';
var utils = require('./../../global/utils');
const html2Text = require('../../utils/html2Text');
var isEmpty = utils.isEmpty;

function convert(content) {
  switch(content.type) {
    case 'audio':
      content.msg = '[语音留言]';
      break;
    case 'video':
      content.msg = '[视频]';
      break;
    case 'text':
      content.msg = html2Text(content.msg)
      break;
    case 'card':
    case 'minicard':
    case 'universal_card1':
    case 'universal_card2':
    case 'universal_card3':
    case 'mix':
    case 'universal_card4':
    case 'universal_card5':
    case 'universal_card6':
    case 'private_card_ganji':
      content.msg = '[卡片]';
      break;
    case 'file':
      content.msg = '[文件]';
      break;
    case 'location':
      content.msg = '消息格式暂不支持，请在客户端查看';
      break;
    case 'call_audio':
      content.msg = '[收到一条语音聊天消息，请在手机上查看]';
      break;
    case 'call_video':
      content.msg = '[收到一条视频聊天消息，请在手机上查看]';
      break;
    case 'image':
      content.msg = '[图片]';
      break;
    case 'provide_contactinfo_card':
    case 'default_contactinfo_card':
      content.msg = '[用户名片]';
      break;
    case 'msg_batch_forward_card':
      content.msg = '[聊天记录]';
      break;
    default:
      content.msg = '消息格式暂不支持，请在客户端查看';
      break;
  }
  return content;
};

var CardBatchMsgItem = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);
    // 是否已经被render过
    this._rendered = false;
};
CardBatchMsgItem.prototype = Object.create(BaseMsgItem.prototype);
CardBatchMsgItem.prototype.renderContent = function () {
    var self = this;
    var msg = this._data.msg;
    var msgcontent = msg.content;
    var batch_title = msgcontent.card_title || '';
    var batch_body = '';
    var message_content;
    if(msgcontent.type === 'msg_batch_forward_card'){
      if(batch_title){
        this._element.find('.im-msg-content .im-msg-forward-title .im-msg-forward-to').html(batch_title);
      }
      (msgcontent.msgs_preview || []).forEach(function(message, index){
        if(index<=3){
          message_content = (message.content ? message.content : '{}');
          try {
            if (typeof message_content === 'string') {
              message_content = JSON.parse(message_content);
            }
          }catch(e){
            message_content = {};
          }
          message_content = convert(message_content);
          batch_body += paragraph.replace('${name}', message.sender_name).replace('${message}', (message_content.msg || ''));
        }
      });
      this._element.find('.im-msg-content .im-msg-forward-body').html(batch_body);
      var $content = this._element.find('.im-msg-content');
      $content.click(function (e) {
        e.stopPropagation();
        self.handleMsgClick.apply(self, [msg]);
      });
    }
};

CardBatchMsgItem.prototype.handleMsgClick = function (msg) {
  if (!(isEmpty(msg.status) || msg.status === 'SUCCESS')) {
    return;
  }
  var msgcontent = msg.content;
  var batch_title = msgcontent.card_title || '';
  if (msgcontent.msgs && msgcontent.msgs.length) {
    var msg_ids = [];
    var id_sources = {};
    var sender_id;
    var to_id;
    msgcontent.msgs.forEach(function(msg){
      msg_ids.push(msg.msg_id);
      sender_id = msg.sender_id.split('@@');
      to_id = msg.to_id.split('@@');
      if (sender_id.length >=2 && to_id.length >=2) {
        id_sources[msg.msg_id] = {
          sender_id: sender_id[0],
          sender_source: Number(sender_id[1]),
          to_id: to_id[0],
          to_source: Number(to_id[1])
        }
      }
    });
    if(msg.msg_collect ==="collect" ||  msg.msg_showtype ==="collect"){
      if (typeof msg.content === 'string') {
        msg.content = JSON.parse(msg.content);
      }
      var contentMsgs = msg.content.msgs;
      var allForwardMsgs = msg.forward_msgs;
      var forwardMsgIds = [];
      var currentForwardMsgs = [];
      // msg.msgs.forEach(msgMsg => {
      //   msgMsg.forward_msgs = msg.forward_msgs;
      //   msgMsg.msg_collect = 'collect';
      // });
      contentMsgs.forEach(contentMsg => {
        forwardMsgIds[contentMsg.msg_id] = contentMsg.msg_id
      });
      allForwardMsgs.forEach(forwardMsg => {
        if(forwardMsgIds[forwardMsg.msg_id]){
          currentForwardMsgs.push(forwardMsg)
        }
      });
      currentForwardMsgs.forEach(currentforwardMsg => {
        if (typeof currentforwardMsg.content=== 'string') {
          currentforwardMsg.content = JSON.parse(currentforwardMsg.content);
        }
        if(currentforwardMsg.content.type == "msg_batch_forward_card"){
          currentforwardMsg.forward_msgs = msg.forward_msgs;
          currentforwardMsg.msg_collect = 'collect';
        }
      });
      dispatcher.dispatch({
        type: ActionType.COLLECTION_MESSAGE_FLOAT,
        data: {
          msgList: currentForwardMsgs,
          title: batch_title,
          id: msg.msg_id,
          parent_u_key:msg.content._parent_u_key ?msg.content._parent_u_key:''

        }
      });
      return
    }
    dispatcher.dispatch({
      type: ActionType.FORWARD_MESSAGE_FLOAT,
      data: {
        msg_ids: msg_ids,
        id: msg.msg_id,
        sender_id: msg.sender_id,
        sender_source: msg.sender_source,                  
        to_id: msg.to_id,                             
        to_source: msg.to_source,
        parent_u_key: msgcontent._parent_u_key,
        root_u_key: msgcontent._root_u_key,
        title: batch_title,
        id_sources: id_sources
      }
    });
  }
};

module.exports = CardBatchMsgItem;
